import * as History from 'history'
import { AjaxWrapper } from './ajaxWrapper'
import { StateKey, StateManager } from './state'

const SELECTED_COMMUNITY_Q: string = 'c'
const AUTH_TOKEN_Q: string = 't'
const CLEAR_TOKEN_Q: string = 'clear'

const history = History.createBrowserHistory()

declare const RASA_SELF_SERVICE_API;

export enum AuthenticationStatus {
  NO_TOKEN,
  NO_COMMUNITY,
  INVALID_TOKEN,
  NO_ACCESS,
  VALID,
}

export const logout = () => {
  StateManager.clearValue(StateKey.AUTH_TOKEN)
}

export const login = (email: string, password: string) => {
  const body = {
    email,
    password,
    is_hubspot_ui: true,
    identity_provider: 'cognito',
  }
  return fetch(`${RASA_SELF_SERVICE_API}/auth/dashboard/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (response.ok) {
      return response.json()
        .then((payload) => {
          StateManager.setValue(StateKey.AUTH_TOKEN, payload.token)
          return {
            success: true,
            ...payload
          }
        })
    } else {
      return {
        success: false,
        message: 'Sorry, that is not the correct password'
      }
    }
  }).catch((err) => {
    return {
      success: false,
      message: 'Something went wrong!'
    }
  })
}

export const validateRequest = (): Promise<AuthenticationStatus> => {
  const queryParams: URLSearchParams = new URLSearchParams(history.location.search)
  if (queryParams.get(CLEAR_TOKEN_Q)) {
    StateManager.clearValue(StateKey.AUTH_TOKEN)
  }

  StateManager.setValue(StateKey.COMMUNITY, queryParams.get(SELECTED_COMMUNITY_Q))
  const selectedCommunity: string = StateManager.getValue(StateKey.COMMUNITY)
  if ( !selectedCommunity) {
    return Promise.resolve(AuthenticationStatus.NO_COMMUNITY)
  }

  StateManager.setValue(StateKey.AUTH_TOKEN, queryParams.get(AUTH_TOKEN_Q))
  const authToken = StateManager.getValue(StateKey.AUTH_TOKEN)
  if ( !authToken ) {
    return Promise.resolve(AuthenticationStatus.NO_TOKEN)
  }

  queryParams.delete(AUTH_TOKEN_Q)
  history.replace(history.location.pathname + '?' + queryParams)

  return fetch(`${RASA_SELF_SERVICE_API}/auth/token`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + authToken,
    },
  }).then((response) => {
    if ( response.status !== 200 ) {
      // flush the token, but keep the community
      logout()
      return AuthenticationStatus.INVALID_TOKEN
    } else {
      return response.json()
                     .then((payload) => {
                       const communityRole: any = payload.roles[selectedCommunity] || payload.roles['newsbrief-defaults']
                       if ( communityRole ) {
                         AjaxWrapper.setToken(authToken)
                         return AuthenticationStatus.VALID
                       } else {
                         return AuthenticationStatus.NO_ACCESS
                       }
                     })
    }
  })
}
